/**
 * ============================================================
 * FILE: utils/version.js – Central Application Version Helper
 * ============================================================
 */

// @ts-ignore
export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '1.0.11';
